const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/ideas/all/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { ideaSchema } from '../view/$viewId';
export const Route = createFileRoute('/(app)/org/$org/idea-management/ideas/all/')({
  validateSearch: search => ideaSchema.parse(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {},
    collapseLeftNav: true
  }
});